import React, { useState } from 'react'
import { Modal, TextField } from '@ann/web-components'
import { observer } from 'mobx-react';
import { useDrivesStores } from '../../hook/use-drives.hook';
import { ErrorMessage } from './NewDriveModal.styled';

const NewDriveModal = ({
    size="medium",
    modalWidth= '500px',
    isOpen,
    onClose,
    onSave,
    disabled = false
}) => {
    const drivesPageStore = useDrivesStores();
    const [driveName, setDriveName] = useState('');
    const [isCreating, setIsCreating] = useState(false);
    
    const isFieldEmpty = !driveName.trim();
    const showError = isFieldEmpty;

    const handleSave = async () => {
        try {
            setIsCreating(true);
            
            const driveData = {
                scope: 'MANAGE',
                name: driveName || 'Untitled Drive',
                description: '-',
                category: 'MANAGE',
                metadata: {},
                access_level: 'private',
                //image_url: null,
                //vector_store_uuid: null
            };
            await drivesPageStore.drivesViewStore.createDrive(driveData);
            onClose();
            setDriveName('');
            
        } catch (error) {
            console.error('Error creating drive:', error);
        } finally {
            setIsCreating(false);
        }
    };

    const handleClose = () => {
        setDriveName('');
        setIsCreating(false);
        onClose();
    };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} width={modalWidth} size={size}>
        <Modal.Header>
        <Modal.Header.Title>
            New drive
        </Modal.Header.Title>
        </Modal.Header>
        <Modal.Body>
            <TextField 
                label="Drive Name"
                size="small" 
                placeholder="Untitled Drive"
                value={driveName}
                onChange={(value) => setDriveName(value)}
                required={true}
            />
            {showError && (
                <ErrorMessage>Drive name is required</ErrorMessage>
            )}
        </Modal.Body>
        <Modal.Actions align="end">
        <Modal.Button
            label="Cancel"
            onClick={handleClose}
            type="secondary"
        />
        <Modal.Button
            label={isCreating ? "Creating..." : "Save"}
            onClick={handleSave}
            disabled={disabled || isCreating || isFieldEmpty}
        />
        </Modal.Actions>
    </Modal>
  )
}

export default observer(NewDriveModal)